// languageUtils.js

export const languages = [
    {
      code: "fr",
      name: "Français",
      country_code: "fr",
    },
    {
      code: "en",
      name: "English",
      country_code: "gb",
    },
    {
      code: "pt",
      name: "Português",
      country_code: "pt",
    },
    {
      code: "es",
      name: "Español",
      country_code: "es",
    },
    {
      code: "ar",
      name: "العربية",
      country_code: "sa",
      dir: "rtl",
    },
  ];
  
  class LanguageUtils {
    // Retrieve a language by code
    static getByCode(code) {
      return languages.find((lang) => lang.code === code) || null;
    }
  
    // Retrieve a language by name
    static getByName(name) {
      return (
        languages.find(
          (lang) => lang.name.toLowerCase() === name.toLowerCase()
        ) || null
      );
    }
  
    // Retrieve a language by country_code
    static getByCountryCode(countryCode) {
      return (
        languages.find(
          (lang) => lang.country_code.toLowerCase() === countryCode.toLowerCase()
        ) || null
      );
    }
  
    // Retrieve all languages
    static getAllLanguages() {
      return languages;
    }
  }
  
  export default LanguageUtils;